import React from 'react'
import { Box } from '@chakra-ui/react'
const Follow = () => {
  return (
    <Box fontSize={"5xl"} fontStyle={"italic"} textAlign={"center"}>
      Still in development phase.
    </Box>
  )
}

export default Follow